import React, { useState } from 'react';
import { B } from '../constants';
import { partners as partnersApi } from '../api';

const CATEGORY_ICONS = {
  hotel: '\u{1F3E8}',
  activity: '\u{1F3AB}',
  flight: '\u2708\uFE0F',
  transfer: '\u{1F697}',
  insurance: '\u{1F6E1}\uFE0F',
  esim: '\u{1F4F1}',
};

export default function PartnerBadge({ partner, destination, origin, startDate, endDate, adults, compact, onBook }) {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const params = {};
      if (destination) params.destination = destination;
      if (origin) params.origin = origin;
      if (startDate) params.startDate = startDate;
      if (endDate) params.endDate = endDate;
      if (adults) params.adults = adults;

      const { deepLink } = await partnersApi.deeplink(partner.slug, params);
      if (onBook) onBook(partner, deepLink);
      window.open(deepLink, '_blank', 'noopener,noreferrer');
    } catch (err) {
      console.error('Failed to get deeplink', err);
    } finally {
      setLoading(false);
    }
  };

  const icon = CATEGORY_ICONS[partner.category] || '\u{1F30D}';

  if (compact) {
    return (
      <button
        onClick={handleClick}
        disabled={loading}
        style={{
          display: 'inline-flex', alignItems: 'center', gap: 6,
          padding: '6px 14px', borderRadius: 50, border: `1px solid ${B.sand}`,
          background: 'white', cursor: loading ? 'wait' : 'pointer',
          fontFamily: "'Montserrat',sans-serif", fontSize: 12, fontWeight: 600,
          color: B.night, transition: 'all 0.2s', whiteSpace: 'nowrap',
        }}
        onMouseEnter={e => { e.currentTarget.style.borderColor = B.forest; e.currentTarget.style.boxShadow = `0 2px 8px rgba(26,107,74,0.15)`; }}
        onMouseLeave={e => { e.currentTarget.style.borderColor = B.sand; e.currentTarget.style.boxShadow = 'none'; }}
      >
        {icon} {partner.name}
      </button>
    );
  }

  return (
    <button
      onClick={handleClick}
      disabled={loading}
      style={{
        display: 'flex', alignItems: 'center', gap: 12,
        padding: '12px 20px', borderRadius: 14, border: `1px solid ${B.sand}`,
        background: 'white', cursor: loading ? 'wait' : 'pointer',
        fontFamily: "'Montserrat',sans-serif", fontSize: 14,
        color: B.night, transition: 'all 0.2s', width: '100%',
        textAlign: 'left',
      }}
      onMouseEnter={e => { e.currentTarget.style.borderColor = B.forest; e.currentTarget.style.boxShadow = `0 4px 12px rgba(26,107,74,0.1)`; }}
      onMouseLeave={e => { e.currentTarget.style.borderColor = B.sand; e.currentTarget.style.boxShadow = 'none'; }}
    >
      <span style={{ fontSize: 24 }}>{icon}</span>
      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: 700, marginBottom: 2 }}>{partner.name}</div>
        <div style={{ fontSize: 12, color: B.muted }}>{partner.category}</div>
      </div>
      <span style={{ fontSize: 18, color: B.forest }}>{loading ? '\u23F3' : '\u2197'}</span>
    </button>
  );
}
